import type { RouteObject } from 'react-router';
import { FlaggedAreasPage } from './pages/FlaggedAreasPage';

export const FLAGGED_AREA_ROUTES: RouteObject[] = [
  { path: 'zones/flagged', element: <FlaggedAreasPage /> },
  { path: 'zones/flagged/new', element: <FlaggedAreasPage panel="new" /> },
  { path: 'zones/flagged/:id', element: <FlaggedAreasPage panel="area" /> },
];
